import { render } from "./upload_proof_of_address.html?vue&type=template&id=302be14c&external"
import script from "./upload_proof_of_address.js?vue&type=script&lang=js&external"
export * from "./upload_proof_of_address.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__